
import { supabase } from "@/integrations/supabase/client";

export const setupRealtimeSubscription = (currentUserId: string, onNewRequest: (id: string) => void) => {
  const channel = supabase
    .channel('service_requests_changes')
    .on('postgres_changes', { 
      event: 'INSERT', 
      schema: 'public',
      table: 'service_requests',
      filter: `user_id=eq.${currentUserId}`
    }, (payload) => {
      console.log('New service request received:', payload);
      onNewRequest(payload.new.id);
    })
    .subscribe();

  return () => {
    supabase.removeChannel(channel);
  };
};
